<template>
  <div>
    <wc-data-box
      :title='storePath.title'
      :titleIcon='storePath.icon'
      :titleIconColor='storePath.iconColor'
      showEdit
      @edit="$emit('edit')"
    >
      <v-simple-table dense>
        <tbody>
          <tr>
            <td :class='label'>Start</td>
            <td :class='dataValue'>{{ entry.start | time }}</td>
          </tr>
          <tr>
            <td :class='label'>Stop</td>
            <td :class='dataValue'>{{ entry.end | time }}</td>
          </tr>
          <tr>
            <td :class='label'>Hours Worked</td>
            <td :class='dataValue'>{{ entry.hours_worked }}</td>
          </tr>
          <tr>
            <td :class='label'>Took Lunch</td>
            <td :class='dataValue'>{{ entry.had_lunch | trueFalse }}</td>
          </tr>
          <tr>
            <td :class='label'>KMs</td>
            <td :class='dataValue'>{{ entry.kms }}</td>
          </tr>
          <tr v-if='entry.kms_notes'>
            <td :class='label'>KMs Reason:</td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-card-text v-if='entry.kms_notes' v-html='entry.kms_notes' class='pt-0'>
      </v-card-text>
    </wc-data-box>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules'

export default {
  name: 'timesheets-overview-basics',
  props: {
    entry: {
      required: true
    }
  },
  mixins: [formRules],
  data: () => ({
    label: 'grey--text',
    dataValue: 'text-right',
  }),
  computed:{
    storePath () { return this.$store.state.icons.dataBox.basics }
  },
  methods: {

  },
  components: {

  }
}
</script>